/**
 * Format a duration given in seconds.
 *
 * Rules:
 *   - s < 3600       -> "mm:ss" (zero-padded minutes + seconds)
 *   - s >= 3600      -> "H:mm:ss" (no zero-pad on hours, zero-pad minutes + seconds)
 *   - null / undefined / negative / non-finite -> "—"
 */
export function formatDuration(seconds: number | null | undefined): string {
  if (seconds == null || !Number.isFinite(seconds) || seconds < 0) {
    return '—';
  }
  const total = Math.floor(seconds);
  const h = Math.floor(total / 3600);
  const m = Math.floor((total % 3600) / 60);
  const s = total % 60;
  const pad2 = (n: number): string => (n < 10 ? `0${n}` : `${n}`);
  if (h > 0) {
    return `${h}:${pad2(m)}:${pad2(s)}`;
  }
  return `${pad2(m)}:${pad2(s)}`;
}
